import { MARKER_DATA_UPDATED } from '../actions/markerData';

const markerData = (state = { 
  infoWindowType: 'single',
  showTooltip: false,
  activeMarker: null,
  activeResult: null 
}, action) => {
	switch (action.type) {
		case MARKER_DATA_UPDATED:
      return {
        ...state,
        infoWindowType: action.infoWindowType,
        showTooltip: action.showTooltip,
        activeMarker: action.activeMarker,
        activeResult: action.activeResult
      };
		default:
			return state;
	}
};

export default markerData;